import { render, staticRenderFns } from "./FormBtn.vue?vue&type=template&id=79fb08a0&scoped=true&"
import script from "./FormBtn.vue?vue&type=script&lang=js&"
export * from "./FormBtn.vue?vue&type=script&lang=js&"
import style0 from "./FormBtn.vue?vue&type=style&index=0&id=79fb08a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fb08a0",
  null
  
)

export default component.exports